// Hero strip — ikon + kod + ad + KPI rozetleri
// Modal'ın hemen üstüne (subtitle yerine veya bodyTop slot olarak) yerleştirilir.
import React from 'react';
import CardKpiBadge from './CardKpiBadge';

export default function CardHero({
  icon,           // emoji veya JSX
  code,           // küçük üst metin (örn STK-001)
  title,          // ana başlık (örn Vidalı Conta M8)
  subtitle,       // alt metin (örn Demir-Çelik → Bağlantı Elemanları)
  statusBadge,    // sağda durum rozeti (CardStatusBadge JSX'i)
  actions,        // sağda ek butonlar (favori, kopya vb)
  kpis = [],      // [{ label, value, color, sublabel, onClick }]
  compact = false,
}) {
  return (
    <div style={{
      marginBottom: 16,
      padding: compact ? '10px 12px' : '12px 14px',
      background: 'var(--bg-secondary)',
      border: '1px solid var(--border-secondary)',
      borderRadius: 'var(--r-lg)',
    }}>
      <div style={{
        display: 'flex', justifyContent: 'space-between',
        alignItems: 'flex-start', gap: 12, flexWrap: 'wrap',
      }}>
        <div style={{ flex: 1, minWidth: 220, display: 'flex', alignItems: 'center', gap: 12 }}>
          {icon && (
            <div style={{
              fontSize: compact ? '1.4rem' : '1.8rem',
              lineHeight: 1, flexShrink: 0,
            }}>{icon}</div>
          )}
          <div style={{ minWidth: 0, flex: 1 }}>
            {code && (
              <div style={{
                fontSize: '0.72rem',
                color: 'var(--text-tertiary)',
                fontFamily: 'JetBrains Mono, monospace',
                marginBottom: 1,
              }}>{code}</div>
            )}
            {title && (
              <div style={{
                fontSize: compact ? '0.95rem' : '1.05rem',
                fontWeight: 700,
                color: 'var(--text-primary)',
                lineHeight: 1.2,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}>{title}</div>
            )}
            {subtitle && (
              <div style={{
                fontSize: '0.74rem',
                color: 'var(--text-secondary)',
                marginTop: 2,
              }}>{subtitle}</div>
            )}
          </div>
        </div>
        {(statusBadge || actions) && (
          <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexShrink: 0 }}>
            {statusBadge}
            {actions}
          </div>
        )}
      </div>

      {kpis.length > 0 && (
        <div style={{
          display: 'flex', gap: 8, marginTop: 12,
          flexWrap: 'wrap',
        }}>
          {kpis.map((k, i) => (
            <CardKpiBadge key={k.key || k.label || i} compact={compact} {...k} />
          ))}
        </div>
      )}
    </div>
  );
}
